<eb-favorites-item-header
  *ngIf="hasHeader"
  [compact]="displayEntriesCompact"
  [showPrice]="showPriceValue"
  [hideQuantity]="hideQuantity"
  [isAllSelected]="isAllSelected"
  (allItemsSelected)="selectAllItems($event)"
></eb-favorites-item-header>
<div class="cx-item-list-row" *ngFor="let item of currentOrderEntries">
  <eb-favorites-item
    [item]="item"
    [readonly]="readonly"
    [options]="options"
    [compact]="displayEntriesCompact"
    [showPrice]="showPriceValue"
    isAvailabilityProvidedByParent="true"
    [availability]="productAvailabilities.get(item.product.code)"
    [prices]="
      item.product?.successor && !item.product?.orderable
        ? this.productPrices.get(item.product?.successor?.code)
        : this.productPrices.get(item.product?.code)
    "
    [showAddToCart]="showAddToCart"
    [hideQuantity]="hideQuantity"
    (itemSelected)="onSelectedItemChange($event)"
    (removeSelectedItem)="onRemoveSelectedItem($event)"
    (editCommentOnEntry)="onEditCommentOnEntry($event)"
  >
  </eb-favorites-item>
</div>
<eb-load-more-button
  *ngIf="currentOrderEntries?.length < items?.length"
  (clicked)="nextPage()"
></eb-load-more-button>
